import { Button, H2, InputEmail } from "@sellar-io/components";
import { useForm, useWatch } from "react-hook-form";
import { InputContainer } from "@sellar-io/components";
import { useFullPageDialogContext } from "../../../../../../../../components/modal/useFullPageDialogContext";
import { useBusinessUserCreditInvite } from "../../../../../../../../hooks/api/v2/businessUser/useBusinessUserCreditInvite";
import { useSellarCurrentBusiness } from "../../../../../../../../hooks/useSellarCurrentBusiness.shared";
import { useState } from "react";
import { Alert } from "../../../../../../../../components/alert/Alert";
import { apiV2AssertError } from "../../../../../../../../hooks/api/v2/apiV2Request";
import {
  SellarCreditTwoDialogPage,
  SellarCreditTwoHeroImage,
} from "./SellarCreditTwoDialogPage";

export const SellarCreditCheckInviteDirector = () => {
  const { business } = useSellarCurrentBusiness();
  const businessUserCreditInviteMutation = useBusinessUserCreditInvite(
    business?.id ?? 0,
  );
  const { onDismiss } = useFullPageDialogContext();
  const [error, setError] = useState<string>();

  const { register, handleSubmit, control } = useForm({
    shouldUseNativeValidation: true,
    defaultValues: {
      email: "",
    },
  });
  const email = useWatch({
    control,
    name: "email",
  });
  const disabled = email === "";

  const onSubmit = (data: { email: string }) => {
    businessUserCreditInviteMutation.mutate(
      {
        email: data.email,
      },
      {
        onSuccess: () => {
          if (onDismiss) onDismiss();
        },
        onError: (error) => {
          const errorMessage = apiV2AssertError(error)?.response?.data.message;
          setError(errorMessage ?? "An unknown error has occurred");
        },
      },
    );
  };

  return (
    <SellarCreditTwoDialogPage>
      <form
        className="flex w-full flex-col items-center gap-4"
        onSubmit={handleSubmit(onSubmit)}
      >
        <SellarCreditTwoHeroImage
          src="https://sellar.imgix.net/sellar-image-assets/sellar-credit/send-link.svg"
          width={230}
          height={185}
          className="w-[230px]"
        />
        <H2>No problem, send a link instead</H2>
        <p className="text-zinc-800">
          If you don’t have access to your company’s banking information, you
          can send a link to somebody in your company who does.
        </p>

        <p className="text-zinc-800">
          They will be asked to complete Two verification instead.{" "}
          <span className="font-semibold">Enter their email below</span>
        </p>

        <InputContainer className="w-full">
          <InputEmail
            {...register("email", { required: true })}
            placeholder="name@email.com"
            className="w-full"
          />
        </InputContainer>
        {!!error && (
          <Alert type="error" title="Cannot send link" message={error} />
        )}
        <div className="flex w-full flex-col gap-2">
          <Button disabled={disabled} className="w-full" type="submit">
            Send magic link
          </Button>
        </div>
      </form>
    </SellarCreditTwoDialogPage>
  );
};
